import React from "react";
import insuranceArrow from "assets/svg/insuranceArrow.svg";
import "./style.scss";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

export const InsuranceCard = ({ heathInsureCardData, textWidth, hideLinks }) => {
	const userID = useSelector(
		(state) => state?.loginDetailsReducer?.loginResponse?.user_info?.userID
	);

	// const handleIconCick = (link) => {
	// 	if (userID) {
	// 		window.location.assign("/" + link)
	// 	} else {
	// 		window.location.assign("/login");
	// 	}
	// }

	return (
		<div className="row">
			{heathInsureCardData.map((item, index) => {
				return (
					<div className={`${item.class} col-lg-3 col-md-3`} key={index}>
						<div className="insuranceBannerCard">
							<div>

								<img
									src={item.cardIcon}
									className="img-fluid"
									id={item.contentAlign}
									alt="icon" />
								<p className={`InsuranceCardText fs-16 fw-800  pt-2`} id={textWidth}>
									{item.content}
								</p>
							</div>
							{!hideLinks && 
								<Link to={userID ? item.link : '/login/'}>
									<img src={insuranceArrow}
										className="img-fluid pb-3 c-pointer" alt="icon" />
								</Link>
							}
							

						</div>
					</div>
				);
			})}
		</div>
	);
};
